module.exports = __webpack_public_path__ + "award.svg";


//////////////////
// WEBPACK FOOTER
// ./public/icons/award.svg
// module id = 2395
// module chunks = 0